import { createContext } from 'react'

export const GoogleContext = createContext<gapi.auth2.BasicProfile | undefined>(
  undefined
)
